import { Pregunta, PreguntaRespuesta, SurveyStepsHandler } from '@/hooks/useSurvey';
import { getIsTouchDevice } from '@/utils';
import { useMediaQuery } from '@/hooks';

import './index.css';

interface FacesRadioStepProps {
    step: Pregunta;
    answers: PreguntaRespuesta[];
	showText?: boolean,
    handleSurveySteps: SurveyStepsHandler;
    iStep: number;
    finalStep: boolean;
    handleNext: () => void;
}

const FacesRadioTexts = [
	'Muy malo',
	'Malo',
	'Regular',
	'Bueno',
	'Excelente'
]

export const FacesRadioStep = ({
    step,
    answers,
	showText = false,
    handleSurveySteps,
    iStep,
    handleNext,
    finalStep,
}: FacesRadioStepProps) => {
    const isTouchDevice = getIsTouchDevice();
    const xs = useMediaQuery('(min-width: 500px)');

    return (
        <>
            <div
                className={`
                    ${isTouchDevice && xs ? 'flex justify-center' : ''}
                    ${isTouchDevice ? 'pb-10' : 'pb-2.5'}
                `}
            >
                {/* <div
                    className={`
                        ${isTouchDevice ? (xs ? 'text-[27px]' : 'text-xl') : 'text-lg'}
                        ${isTouchDevice ? 'text-center' : 'text-right'}
                    `}
                    dangerouslySetInnerHTML={{ __html: step.cPregunta }}
                >
                    {step.cPregunta}
                </div> */}
                <strong
                    className={`
                        ${isTouchDevice ? (xs ? 'text-[27px]' : 'text-xl') : 'text-lg'}
                        ${isTouchDevice ? 'text-center' : 'text-left'}
                    `}
                >
                    {step.cPregunta}
                </strong>
            </div>

            <div className="mt-1 flex w-full justify-around cont-respuestas">
                {answers.map((answer, index) => (
                    <div
                        key={index}
                        className="w-[16%] cursor-pointer transition-all duration-300 ease-in-out hover:scale-[1.03] hover:shadow-lg item-respuesta"
                        onClick={() => {
                            handleSurveySteps(iStep, 'nRespuesta', answer.nValor);
                            if (!finalStep) handleNext();
                        }}
                    >
                        <div
                            className={`
                                flex aspect-square w-full flex-col items-center justify-between
                                text-center
                                ${step.nRespuesta === answer.nValor ? 'bg-primary-100' : 'bg-default-200'}
                            `}
                        >
                            <img
                                src={answer.cUrl}
                                alt={answer.cDescripcion}
                                className="h-full w-full object-contain"
                            />
							<span>
								{showText && FacesRadioTexts[answer.nValor - 1]}
							</span>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};
